// extracted by mini-css-extract-plugin
export default {"wrapper":"MenuEdit_wrapper__lW-Ny"};